module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XV"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("ACW")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Ancient Christian Writers: The Works of the Fathers in Translation. Mahwah, N.J.: Paulist, 1946-.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("AF")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("J. B. Lightfoot and J. R. Harmer, trans. "), _c('i', [_vm._v("The Apostolic Fathers.")]), _vm._v(" Edited by M. W. Holmes. 2nd ed. Grand Rapids, Mich.: Baker, 1989.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("AHSIS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Dana Miller, ed. "), _c('i', [_vm._v("The Ascetical Homilies of Saint Isaac the Syrian.")]), _vm._v(" Boston, Mass.: Holy Transfiguration Monastery, 1984.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("CSEL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Corpus Scriptorum Ecclesiasticorum Latinorum. Vienna, 1866-.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("CWS")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Classics of Western Spirituality: A Library of the Great Spiritual Masters. Mahwah, N.J.: Paulist Press, 1978-. These volumes are not numbered. Numbers in the notes refer to page numbers in the volume for the appropriate author cited.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("FC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Fathers of the Church: A New Translation. Washington, D.C.: Catholic University of America Press, 1947-.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("FGFR")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("F. W. Norris. "), _c('i', [_vm._v("Faith Gives Fullness to Reasoning: The Five Theological Orations of Gregory Nazianzen")]), _vm._v(". Leiden and New York: E. J. Brill, 1990.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("HOP")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Ephrem the Syrian. "), _c('i', [_vm._v("Hymns on Paradise.")]), _vm._v(" Edited by S. Brock. New York: St. Vladimir’s Seminary Press, 1990.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("JTS")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Journal of Theological Studies.")]), _vm._v(" (Citations in this volume are from Origen, “Fragments on the Pauline Epistles,” "), _c('i', [_vm._v("JTS")]), _vm._v(" 3 [1902]; "), _c('i', [_vm._v("JTS")]), _vm._v(" 9-10 [1908-1909]; "), _c('i', [_vm._v("JTS")]), _vm._v(" 13-14 [1912-1913].)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("LCC")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("J. Baillie et al., eds. The Library of Christian Classics. 26 vols. Philadelphia: Westminster Press, 1953-1966.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("MOT")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Ronald E. Heine, ed. "), _c('i', [_vm._v("The Montanist Oracles and Testimonia.")]), _vm._v(" North American Patristic Monograph Series 14. Macon, Ga.: Mercer University Press, 1989.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("NPNF")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("P. Schaff et al., eds. A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church. 2 series (14 vols. each). New York: Christian Literature, 1887-1894. Reprint, Grand Rapids, Mich.: Eerdmans, 1952-1956. Reprint, Peabody, Mass.: Hendrickson, 1994.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("NTA 15 ")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("K. Staab, ed. "), _c('i', [_vm._v("Pauluskommentare aus der griechischen Kirche: Aus Katenenhandschriften gesammelt und herausgegeben")]), _vm._v(" (Pauline Commentary from the Greek Church: Collected and Edited Catena Writings). NT Abhandlungen 15. Münster in Westfalen: Aschendorff, 1933. (Commentators: Didymus the Blind of Alexandria, pp. 6–44; Severian of Gabala, pp. 225–98; Theodore of Mopsuestia, pp. 172–200; Theodoret of Cyr, pp. 226–460; Gennadius of Constantinople, pp. 118–19; Oecumenius of Tricca, pp. 432–46.)")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("OFP")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Origen. "), _c('i', [_vm._v("On First Principles.")]), _vm._v(" Translated by G. W. Butterworth. London: SPCK, 1936. Reprint, Gloucester, Mass.: Peter Smith, 1973.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("PG")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("J.-P. Migne, ed. Patrologiae cursus completus. Series Graeca. 166 vols. Paris: Migne, 1857-1886.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("PL")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("J.-P. Migne, ed. Patrologiae cursus completus. Series Latina. 221 vols. Paris: Migne, 1844-1864.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("POG")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renv_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XVI"
    }
  }, [_vm._v("Eusebius. "), _c('i', [_vm._v("Proof of the Gospel.")]), _vm._v(" 2 vols. Translated by W. J. Ferrar. London: SPCK, 1920. Reprint, Grand Rapids: Baker, 1981.")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("SFPSL")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("S. Brock, trans. "), _c('i', [_vm._v("The Syriac Fathers on Prayer and the Spiritual Life.")]), _vm._v(" Kalamazoo, Mich.: Cistercian Publications, 1987.")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 75
// module chunks = 0